<template>
<div>
  PlanPartnerAgent
</div>
</template>

<script>
export default {
  name: 'PlanPartnerAgent'
}
</script>

<style scoped>

</style>
